import sbToolParamsService from "../../../service/paramsService";
import SbToolProjectVersionService from "../../../service/projectVersionService";
import React from "react";
import {observer} from "mobx-react";
import {action} from "mobx";
import {TouchTapEvent} from "material-ui";
import {Criterion} from "../../../domain/criterion/criterionDomain";
import {ColorCircle, StyledMenuItem} from "./SidebarCriteriaMenu.styled";
import ConfirmationDialog from "../../../../core/components/confirmationDialog/confirmationDialog";

interface Props {
  criterion : Criterion
  isValueChanged: boolean
  handleChangeValue: (bool:boolean)=>void
}
@observer
export default class SidebarMenuItem extends React.Component<Props, any> {

  private changeCriterion: ConfirmationDialog;

  @action onSelectCriterion = (e: TouchTapEvent, passedCriterion: any | any[]) => {
    let criterion: Criterion = SbToolProjectVersionService.criteriaList.find(cr => cr.criterionId === passedCriterion.criterionId)
    sbToolParamsService.selectedCriterion = criterion;
    if (criterion.subCriteria.length > 0) {
      sbToolParamsService.selectedSubCriterion = criterion.subCriteria[0];
    }
    sbToolParamsService.selectCriterionVersion(undefined)
    console.warn("Selected criterion : " + criterion.code)
  }

  handlePickCriterion = (e: TouchTapEvent, passedCriterion: any | any[]) => {
      if (this.props.isValueChanged) {
        this.changeCriterion.open(forward => {
            //if click 'yes, delete changed'
          this.props.handleChangeValue(false)
            this.onSelectCriterion(e,passedCriterion)
        },
            stay => {
              return
            })
    } else {
        // if criterion value was not changed
        this.onSelectCriterion(e,passedCriterion)
      }
  }
  submitSaveDialogRefHandler = comp => this.changeCriterion = comp;

  render() {
    const {criterion} = this.props
    let selectedCriterion = sbToolParamsService.selectedCriterion;
    let value = SbToolProjectVersionService.criterionResults[criterion.code]
    let valueStr = value >= 0 ? value : ''
    let selected = selectedCriterion && criterion.criterionId === selectedCriterion.criterionId;

    return (
      <StyledMenuItem onClick={(e) => this.handlePickCriterion(e, criterion)} selected={selected}>
        <ConfirmationDialog ref={this.submitSaveDialogRefHandler}/>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <ColorCircle selected={selected} value={value}/>
          <span>{criterion.code + " " + criterion.name}</span>
        </div>
        <span style={{fontWeight: 700}}>{valueStr}</span>
      </StyledMenuItem>

    )

  }
}



// WEBPACK FOOTER //
// ./src/sbtool/component/ProjectVersionParamsForm/SidebarCriteriaMenu/SidebarMenuItem.tsx